import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { translator } from "../../utils/i18n";
import Tooltip from "@material-ui/core/Tooltip";
import EditIcon from "@material-ui/icons/Edit";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import {
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField
} from "@material-ui/core";
import useForm from "react-hook-form";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { Trans } from "@lingui/macro";
import { DateTime } from "luxon";
import { useDispatch, useSelector } from "react-redux";
import { editUserAttached, getLinkedAccounts } from "../../utils/fetcher";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import { setMessageWithCode } from "../../actions";

export default function EditAccountAttached(props) {
  const [open, setOpen] = React.useState(false);
  const [selectedDate, setSelectedDate] = useState();
  const user = props.user;
  const { handleSubmit, register, setValue } = useForm();

  const dispatch = useDispatch();
  const editUserAttachedFunc = values => dispatch(editUserAttached(values));
  const setMessageWithCodeFunc = values => dispatch(setMessageWithCode(values));

  const message = useSelector(state => state.messageWithCode);
  const today = new Date();
  const minDate = new Date();
  minDate.setFullYear(today.getFullYear() - 150);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setMessageWithCodeFunc({});
    dispatch(getLinkedAccounts());
  };

  const onChangeRadio = e => {
    setValue(e.target.name, e.target.value);
  };

  const handleChangeDob = date => {
    const formatedDate = date
      ? date.day + "/" + date.month + "/" + date.year
      : "";
    setValue("datenaissance", formatedDate);
    setSelectedDate(date);
  };

  useEffect(() => {
    if (Object.keys(user).length) {
      setSelectedDate(
        user.dob
          ? DateTime.fromFormat(user.dob, "d/M/yyyy", {
              locale: "fr"
            })
          : ""
      );
      register({
        name: "civilite",
        value: `${user.civilite === "1" ? "1" : "2"}`
      });
      register({
        name: "datenaissance",
        value: `${user.dob ? user.dob : ""}`
      });
    }
  }, [user]);

  const onSubmit = values => {
    values["iduser"] = user.userId;
    editUserAttachedFunc(values);
  };

  return (
    <>
      <Tooltip title={translator()._("W_MODIFIER")}>
        <button onClick={handleClickOpen}>
          <EditIcon />
          <span className="text">{translator()._("W_MODIFIER")}</span>
        </button>
      </Tooltip>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            {message && message.code && message.text && (
              <div
                className={
                  message.code === 1
                    ? "custom-message justify-content-start custom-success d-flex align-items-center mb-10"
                    : "custom-message justify-content-start custom-alert d-flex align-items-center mb-10"
                }
              >
                {message.code === 1 ? <CheckCircleIcon /> : <ErrorIcon />}
                <div dangerouslySetInnerHTML={{ __html: message.text }} />
              </div>
            )}
            <div className="item-form">
              <FormControl className="inline-radio">
                <FormLabel className="mr-20">
                  {translator()._("W_STEP4_AJOUTER_UNE_PERSONE_CIVILITE")}
                </FormLabel>
                <RadioGroup
                  defaultValue={user.civilite === "1" ? "1" : "2"}
                  name="civilite"
                  onChange={onChangeRadio}
                  row
                >
                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label={translator()._("W_STEP4_CIVILITE_M")}
                  />
                  <FormControlLabel
                    value="2"
                    control={<Radio />}
                    label={translator()._("W_STEP4_CIVILITE_MME")}
                  />
                </RadioGroup>
              </FormControl>
            </div>

            <div className="item-form">
              <div className="item">
                <TextField
                  label={translator()._("W_STEP4_FORMULAIRE_NOM")}
                  variant="outlined"
                  inputRef={register}
                  name="nom"
                  defaultValue={user.lastName}
                />
              </div>
              <div className="item">
                <TextField
                  label={translator()._("W_STEP4_FORMULAIRE_PRENOM")}
                  variant="outlined"
                  inputRef={register}
                  name="prenom"
                  defaultValue={user.firstName}
                />
              </div>
            </div>

            <div className="item-form align-items-flex-end">
              <div className="item">
                <KeyboardDatePicker
                  value={selectedDate}
                  placeholder="jj/mm/aaaa"
                  onChange={handleChangeDob}
                  minDate={minDate}
                  maxDate={today}
                  format="dd/MM/yyyy"
                  label={translator()._("FORMULAIRE_DATE_DE_NAISSANCE")}
                  inputVariant="outlined"
                  name="datenaissance"
                  disableFuture
                  openTo="year"
                  views={["year", "month", "date"]}
                  okLabel={<Trans id="W_STEP_POPUP_BOUTON_OK" />}
                  cancelLabel={<Trans id="W_ANNULER" />}
                  invalidDateMessage={translator()._("W_DATE_INVALID")}
                  maxDateMessage={translator()._("W_MAX_DATE_MESSAGE")}
                  minDateMessage={translator()._("W_MIN_DATE_ALERT")}
                />
              </div>
              <div className="item">
                <label className="custom-label label-small">
                  <Trans id="W_STEP_POPUP_FORMULAIRE_LIEN_DE_PARENTE" />
                </label>
                <div className="wrap-input">
                  <select name="parent" ref={register} className="select">
                    <option
                      selected={user.relationship2.toLowerCase() === "autre"}
                      value="autre"
                    >
                      {translator()._("W_RELATION_AUTRE")}
                    </option>
                    <option
                      selected={user.relationship2.toLowerCase() === "pere"}
                      value="pere"
                    >
                      {translator()._("W_RELATION_PERE")}
                    </option>
                    <option
                      selected={user.relationship2.toLowerCase() === "mere"}
                      value="mere"
                    >
                      {translator()._("W_RELATION_MERE")}
                    </option>
                    <option
                      selected={user.relationship2.toLowerCase() === "conjoint"}
                      value="conjoint"
                    >
                      {translator()._("W_RELATION_CONJOINT")}
                    </option>
                    <option
                      selected={user.relationship2.toLowerCase() === "concubin"}
                      value="concubin"
                    >
                      {translator()._("W_RELATION_CONCUBIN")}
                    </option>
                    <option
                      selected={user.relationship2.toLowerCase() === "enfant"}
                      value="enfant"
                    >
                      {translator()._("W_RELATION_ENFANT")}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={handleClose} color="primary">
              {translator()._("W_STEP_BOUTON_FERMER")}
            </Button>
            <Button type="submit" color="primary" autoFocus>
              {translator()._("W_MODIFIER")}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

EditAccountAttached.propTypes = {
  user: PropTypes.shape({
    civilite: PropTypes.string,
    dob: PropTypes.any,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    relationship2: PropTypes.string,
    userId: PropTypes.any
  })
};
